var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-view"},_vm._l((_vm.defaultdata),function(item,i){return _c('div',{key:i,staticClass:"view-item"},[_c('div',{staticClass:"view-val"},[_vm._v(_vm._s(_vm.validDefaultData[i]))]),_c('div',{staticClass:"view-name"},[_vm._v(_vm._s(item.value1))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }